import { render } from "./AddNewConvert.vue?vue&type=template&id=046ae87e&scoped=true"
import script from "./AddNewConvert.vue?vue&type=script&lang=js"
export * from "./AddNewConvert.vue?vue&type=script&lang=js"

import "./AddNewConvert.vue?vue&type=style&index=0&id=046ae87e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046ae87e"]])

export default __exports__